import { Controller } from "@hotwired/stimulus";

// Submits the form of a field as soon as the field has a value, e.g. a file
// picked for upload. The form keeps its submit button for browsers without
// JavaScript.
export default class extends Controller {
  submit() {
    if (this.element.value) this.element.form.requestSubmit();
  }
}
